<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid style="margin-top: 5%;">
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6">
					<h3>Replace Device</h3>
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
					<!--<b-button variant="dark" pill class="mr-2" @click="showAddModal()">Add Replace</b-button>-->
					<b-button variant="dark" pill class=""  @click="downloadcsv()">Export</b-button>
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
						<b-row class="mt-4 px-3">
							<b-col lg="6">
								<span class="mr-2">Show</span>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>
							</b-col>
							<b-col lg="4" offset-md="2">
								<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
									<template v-slot:cell(status)="row">
										<b-badge pill variant="warning" v-if="row.value == 0">NEW</b-badge>
										<b-badge pill variant="success" v-else-if="row.value == 1">IN PROGRESS</b-badge>
										<b-badge pill variant="secondary" v-else-if="row.value == 2">CLOSED</b-badge>
									</template>
									<!--<template v-slot:cell(actions)="row">
										<b-button pill variant="primary" class="mr-1" v-if="$root.chkperm('page_complaint','edit')" @click="showUpdateModal(row.item, row.index, $event.target)" size="sm">EDIT</b-button>
										<b-button pill variant="danger" class="mr-1" v-if="$root.chkperm('page_complaint','delete')" @click="showDeleteModal(row.item)" size="sm">DELETE</b-button>
									</template>-->
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="6">
								<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>

			
			<b-modal id="my-model" :title="(selectedItem.id > 0)?'Edit Complaint':'Add Complaint'" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
				<form ref="form" @submit.stop.prevent="handleSubmit">
					<b-form-group label="Subject" label-cols="3" label-size="sm" label-align-sm="right" invalid-feedback="Subject is required" v-if="$session.get('user_info').role==1 || selectedItem.id == 0">
						<b-form-select v-model="selectedItem.subject" :disabled="selectedItem.id > 0">
							<b-form-select-option value="0">Select Subject</b-form-select-option>
							<b-form-select-option value="1">Light OFF</b-form-select-option>
							<b-form-select-option value="2">Lights ON at day time</b-form-select-option>
							<b-form-select-option value="3">Meter Burnt</b-form-select-option>
							<b-form-select-option value="4">MCB Burnt</b-form-select-option>
							<b-form-select-option value="5">Disconnected / Network Issue</b-form-select-option>
							<b-form-select-option value="6">Wire Burn</b-form-select-option>
						</b-form-select>
					</b-form-group>
					<b-form-group label="State" label-cols="3" label-size="sm" label-align-sm="right" v-if="$session.get('user_info').role==1">
						<b-form-select v-model="selectedItem.state" :options="$root.state_options" @change="selectedItem.district=0; selectedItem.ulb=0" required></b-form-select>
					</b-form-group>
					<b-form-group label="District" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-select v-model="selectedItem.district" :disabled="selectedItem.id > 0" @change="selectedItem.ulb=0">
							<b-form-select-option value="0">--- Select District ---</b-form-select-option>
							<b-form-select-option v-for="item in filterZone(zones)" v-bind:key="item.id" :value="item.id">{{item.title}}</b-form-select-option>
						</b-form-select>
					</b-form-group>
					<b-form-group label="ULB" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-select v-model="selectedItem.ulb" :disabled="selectedItem.id > 0" @change="fetchLocations()">
							<b-form-select-option value="0">--- Select ULB ---</b-form-select-option>
							<b-form-select-option v-for="item in filterULB(zones)" v-bind:key="item.id" :value="item.id" >{{item.title}}</b-form-select-option>
						</b-form-select>
					</b-form-group>
					<b-form-group label="Locations" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-select v-model="selectedItem.location" :disabled="selectedItem.id > 0">
							<b-form-select-option value="0">--- Select Location ---</b-form-select-option>
							<b-form-select-option v-for="item in locations" v-bind:key="item.fpno" :value="item.fpno" >{{item.location}}</b-form-select-option>
						</b-form-select>
					</b-form-group>
					<b-form-group label="Mobile" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-input v-model="selectedItem.mobile" required maxlength="12" :disabled="selectedItem.id > 0"></b-form-input>
					</b-form-group>
					<b-form-group label="Feeder Pillar" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-input v-model="selectedItem.fp_no" required maxlength="30" :disabled="selectedItem.id > 0"></b-form-input>
					</b-form-group>
                    <b-form-group label="New Message" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-textarea ref="message" v-model="selectedItem.new_message" rows="4" max-rows="16" required></b-form-textarea>
					</b-form-group>
					<b-form-group label="Message" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-textarea v-model="selectedItem.old_message" rows="6" max-rows="16" disabled required></b-form-textarea>
					</b-form-group>
					<b-form-group label="Status" label-cols="3" label-size="sm" label-align-sm="right" v-if="$session.get('user_info').role==1">
						<b-form-select v-model="selectedItem.status" :options="statusOptions" required></b-form-select>
					</b-form-group>
				</form>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
				</template>
			</b-modal>
		
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
	</div>
	
</template>
<script>
import Header from "@/components/Header.vue";
export default {
	name: 'Devices',
	components: {
		"top-header": Header
	},
	mounted(){
		//var self = this;
		//Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
	},
	data() {
		var self = this;
		return{
			loading: true, 
			email: '',
			password: '',
			recordUrl: self.$session.get('apiurl')+'nhaihyd/replacepanel-record',
			insertUrl: self.$session.get('apiurl')+'nhaihyd/replacepanel-insert',
			updateUrl: self.$session.get('apiurl')+'nhaihyd/replacepanel-update',
			deleteUrl: self.$session.get('apiurl')+'nhaihyd/replacepanel-delete',
			locationUrl: self.$session.get('apiurl')+'nhaihyd/ulb-locations',
			records: [],
			locations: [],
			statusOptions: [{ value: 0, text: 'NEW' },{ value: 1, text: 'In Progress' },{ value: 2, text: 'Closed' }],
			zones: [],
			zoneOptions: [],
			fields: [
				{ key: 'id', label: 'ID'},
				{ key: 'feeder_pillar_no', label: 'FP. No.' },
				{ key: 'replace_imei_no', label: 'Replace IMEI' },
				{ key: 'new_imei_no', label: 'New IMEI' },
				{ key: 'replace_meter_no', label: 'Replace Meter' },
				{ key: 'new_meter_no', label: 'New Meter' },
				{ key: 'replace_time', label: 'Replace Time',
                    formatter: (value, key, item) => {
						if(item.replace_time == ""){
							return '00-00-0000 00:00:00';
						}
						return this.$moment(item.replace_time).format('DD-MM-YYYY HH:mm:ss');
					}
                },
                { key: 'insert_time', label: 'Added Time' ,
                    formatter: (value, key, item) => {
						if(item.insert_time == ""){
							return '00-00-0000 00:00:00';
						}
						return this.$moment(item.insert_time).format('DD-MM-YYYY HH:mm:ss');
					}
                }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {state: this.$session.get('user_info').permissions.state_perm},
			emptyItem: {
				id: 0,
				mobile: '',
				subject: 0,
				message: '',
				status: 0
			}
		};
	},
	methods: {
		filterZone: function (items) {
			var self = this;
			return items.filter(function (item) {
				if(item.parent ==0 && item.state == self.selectedItem.state){
					return true;
				}
			})
		},
		filterULB: function (items) {
			var self = this;
			return items.filter(function (item) {
				return item.parent == self.selectedItem.district && item.parent > 0;
			})
		},
		fetchLocations(){
			var self = this;

			self.axios.post(self.locationUrl, {
				accesskey: self.$session.get('access_key'),
				ulb_id: self.selectedItem.ulb
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.locations = response.data.result.locations;
				}else{
					alert('Error in loading locations!');
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		showAddModal(){
			//alert(this.$session.get('user_info').permissions.state);
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.selectedItem.state = this.$session.get('user_info').permissions.state_perm;
			this.$root.$emit('bv::show::modal', 'my-model');
		},
		showUpdateModal(item, index, button) {
			this.selectedItem = Object.assign({}, item);
			this.selectedItem.old_message = '---- Update Time: '+this.$moment(item.update_time).format('DD-MM-YYYY HH:mm:ss')+' ----\n'+item.message;
            
            //this.$refs.message.selectionStart = 1;
            
            
            this.$root.$emit('bv::show::modal', 'my-model', button)
            
           // console.log(this.$refs);
           // this.$refs.message[0].selectionEnd = 1;
		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete complaint.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						deleteid: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}else if(response.data.error == '2' || response.data.error == 2){
							self.$root.forceLogout(response.data.message);
						}else{
							self.$root.showMessage('Server Error', 'Reload again', 'ok', function(){
								self.initload();
							});
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		modalSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			var submitUrl = "";
			if(self.selectedItem.id == 0){
				submitUrl = self.insertUrl;
			}else{
				submitUrl = self.updateUrl;
			}

			self.selectedItem.message = this.selectedItem.new_message+'\n\n'+this.selectedItem.old_message


			self.axios.post(submitUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.selectedItem
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('my-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		
		

		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result;
					self.loading = false;
					self.totalRows = self.records.length;

					//self.zones = response.data.result.zones;
				}
				setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		/*filtercategory(records){
			var filterarr = new Array();
			records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
		},*/
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		downloadcsv(){
			var self = this;
			var header = new Array()
			self.fields.forEach(function(item){
				if(!item.extra){
					header.push(item.label);
				}
			});
			
			//var d = table.rows().data();
			var finalarr = new Array();
			finalarr.push(header);
			self.records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
			
			let csvContent = "data:text/csv;charset=utf-8," 
			+ finalarr.map(e => e.join(",")).join("\n");

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "replace_report.csv");
			document.body.appendChild(link); // Required for FF

			link.click();
		}
	}
}
</script>
<style>
html{
	min-height: 100%;
}
body{
	background-color: '#FFF' !important;
	background-image: none !important;
}
.table{
	font-size: small;
}
.table .btn{
	font-size: 12px;
}
.table td, .table th{
	vertical-align: middle;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
</style>